module.exports = __webpack_public_path__ + "img/three3Orange.9c166a92.jpg";